import { render, staticRenderFns } from "./ApprovedCourses.vue?vue&type=template&id=31caf21c&"
import script from "./ApprovedCourses.vue?vue&type=script&lang=js&"
export * from "./ApprovedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports